/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Card,
  CardContent,
  CardDescription,
  Combobox,
  DatePicker,
  Input,
  PopoverContent,
  Popover,
  PopoverTrigger,
  Button,
  Badge,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import {
  useGetAllLocations,
  useGetOrdersByLocation,
  useUpdateLocationScheduledServices,
} from "utils/apis/home.api";
import { process } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { formatDate } from "date-fns";
import { UserContext } from "utils/reducers/user";
import {
  useGetCustomers,
  useGetCustomerServicePoints,
} from "utils/apis/lookups.api";
import { CircleX, SlidersHorizontal } from "lucide-react";
import { saveFilters } from "utils/actions/user";

import ServicesScheduled from "./servicesScheduled";
import { getLink } from "utils/helper";

const pageSize = 25;

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export default function OrdersByLocation() {
  const user = useContext(UserContext);

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [locations, setLocations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [barcode, setBarcode] = useState("");
  const [selectedLocation, setSelectedLocation] = useState<any>(null);
  const [isAddNewOpen, setIsAddNewOpen] = useState(false);
  const [filters, setFilters] = useState<any>(
    user?.filters?.["location-services"] || {},
  );

  const { data: customers } = useGetCustomers();
  const { data: sourceLocationsData } = useGetCustomerServicePoints(
    filters?.customer?.id || "",
  );

  const { data: allOrders, isFetching: loadingLocations } = useGetAllLocations({
    cashCenterId: user.CashCenterId,
    pageNumber: currentPage,
    pageRowCount: pageSize,
    searchCriteria:
      filters?.searchCriteria?.id.length >= 3
        ? filters?.searchCriteria?.id
        : "",
    customerId: filters?.customer?.id || "",
    operationDate: filters?.operationDate?.id,
    sourceSPId: filters?.sourceLocation?.id || "",
  });

  const { data: ordersByLocation, isError: ordersByLocationError } =
    useGetOrdersByLocation(barcode);

  const { mutate: updateLocationScheduledServices, isPending: updateLoading } =
    useUpdateLocationScheduledServices();

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(user.dispatch, {
      ...user.filters,
      "location-services": updatedFilter,
    });
  };

  const onOperationDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        operationDate: { name: formatDate(value, "PPP"), id: value },
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        "location-services": {
          ...filters,
          operationDate: { name: formatDate(value, "PPP"), id: value },
        },
      });
    }
    setCurrentPage(1);
  };

  const onPageChange = (e: any) => {
    const _currentPage = e.page.skip / e.page.take + 1;
    setCurrentPage(_currentPage);
    setActiveIndex(null);
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };

  const onFilterSearch = (e: any) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      searchCriteria: { name: e.target.value, id: e.target.value },
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "location-services": {
        ...filters,
        searchCriteria: { name: e.target.value, id: e.target.value },
      },
    });
  };

  const handleFiltersUpdate = (key: string, val: any) => {
    const { sourceLocation, ...remainingFilters } = filters;
    setFilters({
      ...(key === "customer" ? remainingFilters : filters),
      [key]: JSON.parse(val),
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "location-services": {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(val),
      },
    });
  };

  const handleBillingCustomer = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("customer", val);
  };

  const handleSourceLocation = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("sourceLocation", val);
  };

  const expandChange = (event: any) => {
    event.dataItem.expanded = Boolean(event.value);

    const index: number = event.dataIndex - pageSize * (currentPage - 1);
    setActiveIndex(index);
    if (!event.value || event.dataItem.detail) {
      setLocations([...locations]);
      return;
    }

    setBarcode(event.dataItem.barcode);
  };

  const onUpdateLocation = () => {
    setSelectedLocation(null);
    setIsScheduleOpen(false);

    updateLocationScheduledServices({
      servicePointId: selectedLocation?.servicePointId,
      serviceSchedules: selectedLocation?.serviceSchedules?.map(
        ({ monthlyDates, deleteId, ...i }: any) => i,
      ),
    });
  };

  function ShowActionCell(props: any) {
    // const { requestId, jobNo, orderId } = props.dataItem;
    return (
      <td className="text-center" {...props}>
        <Button
          variant="secondary"
          onClick={() => {
            setIsScheduleOpen(true);
            setSelectedLocation(props.dataItem);
          }}
        >
          Schedule
        </Button>
      </td>
    );
  }

  function DetailComponent(props: any) {
    const data = props.dataItem.details;

    function ShowOrderIDCell({ dataItem }: any) {
      const { requestId, jobNo } = dataItem;

      return (
        <td>
          {dataItem.serviceType ? (
            <Link
              to={getLink(dataItem?.serviceType)}
              state={{ requestId, jobNo, isReRoute: true }}
            >
              {dataItem.orderId}
            </Link>
          ) : (
            dataItem.orderId
          )}
        </td>
      );
    }

    if (data) {
      return (
        <Grid data={data}>
          <Column field="orderId" cell={ShowOrderIDCell} title="Order Id" />
          <Column field="jobNo" title="Job No" />
          <Column field="routeNo" title="Route No" />
          <Column field="routeDate" title="Route Date" />
          <Column field="departure" title="Departure" />
          <Column field="arrival" title="Arrival" />
          <Column field="collected" title="Collected" />
          <Column field="delivered" title="Delivered" />
        </Grid>
      );
    }

    return (
      <div
        style={{
          height: "50px",
          width: "100%",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "100%",
          }}
        >
          <div className="k-loading-image" />
        </div>
      </div>
    );
  }

  useEffect(() => {
    if (ordersByLocation) {
      const data: any = locations?.slice();

      if (activeIndex || activeIndex === 0) {
        data[activeIndex].details = ordersByLocation || [];
      }
      setLocations(data);
    }

    if (ordersByLocationError) {
      const data: any = locations?.slice();
      if (activeIndex || activeIndex === 0) {
        data[activeIndex].details = [];
      }
      setLocations(data);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ordersByLocation, ordersByLocationError]);

  useEffect(() => {
    if (allOrders?.data) {
      setLocations(allOrders?.data);
    } else {
      setLocations([]);
    }
  }, [allOrders?.data]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Search Orders By Location</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="secondary"
                    className="p-2"
                    title="Apply Filters"
                  >
                    <SlidersHorizontal className="" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent align="start" className="w-[600px]">
                  <h6 className="font-semibold text-lg">Apply Filters</h6>
                  <div className="grid grid-cols-2 gap-4 mt-3">
                    <Combobox
                      placeholder="Select Customer"
                      value={JSON.stringify(filters?.customer) || ""}
                      data={customers?.map((item) => ({
                        value: JSON.stringify({
                          name: item.name,
                          id: item.customerId,
                        }),
                        label: item.name,
                      }))}
                      setValue={handleBillingCustomer}
                    />

                    <Combobox
                      placeholder="Select Source Location"
                      value={JSON.stringify(filters?.sourceLocation) || ""}
                      data={sourceLocationsData?.map((item: any) => ({
                        value: JSON.stringify({
                          name: `${item.barcode}-${item.locationId}`,
                          id: item.servicePointId,
                        }),
                        label: `${item.barcode}-${item.locationId}`,
                      }))}
                      setValue={handleSourceLocation}
                    />
                  </div>
                </PopoverContent>
              </Popover>

              <div className="max-w-[250px] w-full">
                <DatePicker
                  placeholder="Select Operation Date"
                  selectedDate={filters?.operationDate?.id || new Date()}
                  onSelectDate={onOperationDateChanged}
                />
              </div>
              <Input
                className="max-w-[420px] w-full"
                value={filters.searchCriteria?.id}
                onChange={onFilterSearch}
                placeholder="Barcode, Location Name, Location Type and Location Id"
              />
            </div>
            <div className="flex gap-2 flex-wrap mb-3 items-center">
              {Object.entries(filters).map(([key, val]: any, i) =>
                val.id ? (
                  <Badge
                    variant="secondary"
                    className="gap-3 pr-1 cursor-pointer"
                    key={i}
                  >
                    {val?.name}{" "}
                    <CircleX
                      onClick={() => {
                        handleClearFilter(key);
                      }}
                    />
                  </Badge>
                ) : null,
              )}
            </div>
            <div className="border-b mb-3 bg-accent" />
            {loadingLocations ? (
              <div className="k-loading-mask">
                <span className="k-loading-text">Loading</span>
                <div className="k-loading-image" />
                <div className="k-loading-color" />
              </div>
            ) : null}
            <Grid
              className="text-xs"
              data={process(locations || [], {
                ...dataState,
                skip: 0,
              })}
              {...dataState}
              pageable
              onPageChange={onPageChange}
              pageSize={pageSize}
              total={allOrders?.totalRecords}
              skip={(currentPage - 1) * pageSize}
              take={pageSize}
              onDataStateChange={onDataStateChange}
              sortable
              filterable
              size="small"
              detail={DetailComponent}
              expandField="expanded"
              onExpandChange={expandChange}
            >
              <Column field="barcode" title="Barcode" width={200} />
              <Column field="cashCenter" title="Cash Center" width={200} />
              <Column field="customer" title="Customer" width={240} />
              <Column field="locationId" title="Location ID" width={200} />
              <Column field="locationName" title="Name" width={280} />
              <Column
                field="locationType"
                title="Location Type"
                className="text-center"
                width={120}
              />

              <Column
                field="city"
                title="City"
                width={140}
                className="text-center"
              />
              <Column
                field="state"
                title="Region"
                width={140}
                className="text-center"
              />
              <Column title="Action" width={140} cell={ShowActionCell} />
            </Grid>
            <Dialog
              open={isScheduleOpen}
              onOpenChange={(val) => {
                setSelectedLocation(null);
                setIsScheduleOpen(val);
                setIsAddNewOpen(false);
              }}
            >
              <DialogContent className="max-w-[860px]">
                <DialogHeader>
                  <DialogTitle>Schedule Lines</DialogTitle>
                </DialogHeader>
                <DialogDescription className="max-h-[80vh] overflow-auto">
                  <ServicesScheduled
                    selectedLocation={selectedLocation}
                    setSelectedLocation={setSelectedLocation}
                    setIsAddNewOpen={setIsAddNewOpen}
                  />
                  <div className="flex justify-end gap-3 mt-3">
                    <Button
                      variant="outline"
                      onClick={() => {
                        setSelectedLocation(null);
                        setIsScheduleOpen(false);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={onUpdateLocation}
                      isLoading={updateLoading}
                      disabled={!isAddNewOpen}
                    >
                      Save
                    </Button>
                  </div>
                </DialogDescription>
              </DialogContent>
            </Dialog>
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}
